import React, { useEffect, useState } from 'react';
import Topbar from '../../admin/layouts/Topbar';
import '../../superadmin/styles/pages/dashboard.css';
import { Typography, Box, Grid } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { PieChart } from '@mui/x-charts/PieChart';
import instance from '../../utils/Api';
import { useNavigate } from "react-router-dom";
import totalschools_icon from '../../superadmin/assets/icons/dashboard-school-icon.svg';

const Dashboard = () => {
    const navigate = useNavigate();
    const [admins, setAdmins] = useState({});
    const [adminData, setAdminData] = useState({});
    const [reports, setReports] = useState({
        series: [],
        productNames: [],
        data: []
    });
    const [loading, setLoading] = useState(true);

    const fetchAdmins = async () => {
        try {
            const response = await instance.get('Dashboard/AdminDashboard');
            setAdmins(response?.data || {});
        } catch (error) {
            console.error('Error fetching admins:', error.message);
            setAdmins({});
        }
    };

    const fetchAdminByid = async () => {
        try {
            const response = await instance.get('/Admins/getAdminById');
            setAdminData(response?.data?.data || {});
        } catch (error) {
            console.error('Error fetching admin:', error.message);
            setAdminData({});
        }
    };

    const fetchReports = async () => {
        try {
            const response = await instance.get('/Transactions/getreports?interval=monthly');
            const productData = response?.data?.report?.[0]?.uniqueProducts || [];

            if (!productData.length) {
                console.error('No product data found.');
                setReports({
                    series: [],
                    productNames: [],
                    data: []
                });
                return;
            }

            const labels = ["quantity", "revenue"];
            const productNames = productData.map(product => ({
                name: product?.name || 'Unnamed Product'
            }));

            const series = labels.map(label => ({
                label,
                data: productData.map(product => Number(product[label]) || 0),
                highlightScope: { highlight: "series", fade: "global" },
            }));

            setReports({
                series,
                productNames,
                data: productData
            });
        } catch (error) {
            console.error('Error fetching reports:', error);
            setReports({
                series: [],
                productNames: [],
                data: []
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        Promise.all([
            fetchAdmins(),
            fetchAdminByid(),
            fetchReports()
        ]);
    }, []);

    const renderPieChart = () => {
        if (!reports.data?.length) return <Typography>No data available</Typography>;

        return (
            <PieChart
                series={[
                    {
                        data: reports.data.slice(0, 12).map((data) => ({
                            id: data?._id || Math.random().toString(),
                            value: Number(data?.quantity) || 0,
                            label: data?.name || 'Unknown',
                        })),
                        highlightScope: { fade: 'global', highlight: 'item' },
                        faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                        innerRadius: 50
                    },
                ]}
                // width={800}
                height={200}
            />
        );
    };

    const renderBarChart = () => {
        if (loading) return <Typography>Loading...</Typography>;
        if (!reports.series?.length) return <Typography>No data available</Typography>;

        return (
            <BarChart
                height={300}
                // width={800}
                sx={{ overflowX: 'scroll',padding:'10px' }}
                series={reports.series}
                xAxis={[{
                    scaleType: 'band',
                    data: reports.productNames?.map(p => p.name) || []
                }]}
            />
        );
    };

    return (
        <React.Fragment>
            <Topbar />
            <section className="main-2">
                <div className="dashboard-content-text">
                    <Typography variant="h2">
                        Welcome to your dashboard, Mr.Admin
                    </Typography>
                    <Typography variant="h5">{adminData?.email}</Typography>
                </div>

                <section className="dashboard-count">
                    <Grid container spacing={5}>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <div
                                className="dashboard-box"
                                onClick={() => navigate('/admin/wastePickers')}
                            >
                                <img src={totalschools_icon} alt="total_schools" />
                                <Typography>Total Waste Pickers</Typography>
                                <Typography variant="h6">
                                    {admins?.total_drivers || 0}
                                </Typography>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={8}>
                            <div className="dashboard-box">
                                <h1>Items Quantity</h1>
                                {renderPieChart()}
                            </div>
                        </Grid>
                    </Grid>
                </section>

                <section className="admin-section">
                    <div className="dashboard-box">
                        {renderBarChart()}
                    </div>
                </section>
            </section>
        </React.Fragment>
    );
};

export default Dashboard;